export const CHANGE_TOP_BANNERS = "recommend/CHANGE_TOP_BANNERS"
export const CHANGE_HOT_RECOMMENDS ="recommend/CHANGE_HOT_RECOMMENDS"
export const CHANGE_NEW_ALBUMS = "recommend/CHANGE_NEW_ALBUMS"

export const CHANGE_UP_RANKING = "recommend/CHANGE_UP_RANKING"
export const CHANGE_NEW_RANKING = "recommend/CHANGE_NEW_RANKING"
export const CHANGE_ORIGIN_RANKING = "recommend/CHANGE_ORIGIN_RANKING"

export const CHANGE_SETTLE_SONGER = "recommend/CHANGE_SETTLE_SONGER"